import React, { createContext, useState, useEffect } from "react";

export const MediaDisplayContext = createContext();

export const MediaDisplayProvider = ({ children }) => {
  const [displayMode, setDisplayMode] = useState("grid");

  useEffect(() => {
    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    const users = JSON.parse(localStorage.getItem("users")) || [];



    if (loggedIn && users.length > 0) {
      const matchedUserIndex = users.findIndex(
        (u) =>
          (u.userId === loggedIn.userId) &&
          u.password === loggedIn.password
      );

      if (matchedUserIndex !== -1) {
        setDisplayMode(users[matchedUserIndex].mediaDisplayMode || "grid");
      }
    }
  }, []);

  // Whenever displayMode changes, update it back into localStorage for the logged-in user
  useEffect(() => {
    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    const users = JSON.parse(localStorage.getItem("users")) || [];

    if (loggedIn && users.length > 0) {
      const matchedUserIndex = users.findIndex(
        (u) =>
          (u.userId === loggedIn.userId) &&
          (u.password === loggedIn.password)
      );

      if (matchedUserIndex !== -1) {
        users[matchedUserIndex] = {
          ...users[matchedUserIndex],
          mediaDisplayMode: displayMode,
        };
        localStorage.setItem("users", JSON.stringify(users));
      }
    }
  }, [displayMode]);

  return (
    <MediaDisplayContext.Provider value={{ displayMode, setDisplayMode }}>
      {children}
    </MediaDisplayContext.Provider>
  );
};
